export default __webpack_public_path__ + "static/media/slider2.52bf7344.png";